import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Submit a bug report ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "a8-12 f6-6 mb-64" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: {
					name: 'support'
				},
        class: "back-to mb-48"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Back to support ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createElementVNode("iframe", {
          class: _normalizeClass(["clickup-embed clickup-dynamic-height", { 'clickup-embed--hidden': $data.loading }]),
          src: "https://forms.clickup.com/6629531/f/6aa4v-21932/8WDH3GAQ0ZMGDN9QNQ",
          onwheel: "",
          width: "100%",
          style: {"background":"transparent"},
          onLoad: _cache[0] || (_cache[0] = $event => ($data.loading = false))
        }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
          [_directive_resize]
        ])
      ])
    ])
  ]))
}